import { inject } from '@angular/core';
import { RoomEventApiService } from '@shared/services';
import { PopoverConfig, PopoverHandlerConfig } from '../generic-popover.interfaces';
import { roomEventFormConfig } from '@shared/components/edit-create-form';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';

export const roomEventPopoverConfig = (onSuccess: () => void, onCancel: () => void): PopoverConfig => {
  const roomEventApiService = inject(RoomEventApiService);

  return {
    width: '450px',
    title: 'Tạo sự kiện',
    dismissable: false,
    formConfig: roomEventFormConfig(),
    actions: [defaultCancelAction, defaultConfirmAction],
    handlerConfig: {
      service: roomEventApiService,
      method: 'createRoomEvent',
      updateMethod: 'updateRoomEvent',
      entityLabel: 'sự kiện',
      commonDataTransform: (formValue: any) => ({
        name: formValue.name,
        roomId: formValue.roomId,
        userId: formValue.userId,
        fromDate: formValue.fromDate,
        toDate: formValue.toDate
      }),
      updateDataTransform: (formValue: any) => ({
        id: formValue.id
      }),
      initialDataTransform: (rawData: any) => ({
        id: rawData.id,
        name: rawData.name,
        roomId: rawData.roomId,
        userId: rawData.userId,
        fromDate: new Date(rawData.fromDate),
        toDate: new Date(rawData.toDate)
      }),
      onSuccess,
      onCancel
    } as PopoverHandlerConfig
  };
};
